import React from 'react';
import LoadMore from '../LoadMore';
import LoadingSpinner from '../LoadingSpinner';
import FetchDataComponent from '../../components/common/FetchDataComponent';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

class AbstractTable extends FetchDataComponent {
  static propTypes = {
    ...FetchDataComponent.propTypes
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  getStyles() {
    let {
      tableHeaderColumn: { bgColor },
      //baseTheme: { palette: { primary1color }},
      palette: { labelColor },
      textField: { textColor }
    } = this.context.muiTheme;

    let tableColumnStyle = {
      fontSize: 16,
      color: textColor,
      boxSizing: 'border-box'
    };

    let tableHeaderStyle = {
      fontSize: 14,
      color: labelColor,
      boxSizing: 'border-box'
    };

    let header = {
      backgroundColor: bgColor,
      color: labelColor,
      height: 'auto'
    };

    let fixedHeaderStyle = Object.assign({}, tableHeaderStyle, { width: 140 });
    let fixedColumnStyle = Object.assign({}, tableColumnStyle, { width: 140 });

    return {
      header,
      tableColumnStyle,
      tableHeaderStyle,
      fixedColumnStyle,
      fixedHeaderStyle
    };
  }

  render() {
    let { list, items, hasMore, loading } = this.props;
    let records = list.map(id => items[id]);
    let { header } = this.getStyles();

    return (
      <LoadingSpinner show={loading}>
        <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
          <Table selectable={false}>
            <TableHeader
              adjustForCheckbox={false}
              displaySelectAll={false}
              enableSelectAll={false}
              style={header}
              children={this._renderHeader()}
            />

            <TableBody displayRowCheckbox={false}>
              {records.length > 0
                ? records.map((item, key) => this._renderContentItem(item, key))
                : this._renderEmptyState()}
            </TableBody>
          </Table>
        </LoadMore>
      </LoadingSpinner>
    );
  }

  _renderHeader() {
    return (
      <TableRow>
        <TableHeaderColumn>Provide headers</TableHeaderColumn>
      </TableRow>
    );
  }

  // eslint-disable-next-line no-unused-vars
  _renderContentItem(item) {
    return (
      <TableRow>
        <TableRowColumn>Provide content</TableRowColumn>
      </TableRow>
    );
  }

  _renderEmptyState() {
    return (
      <TableRow>
        <TableRowColumn columnNumber={6}>Empty list</TableRowColumn>
      </TableRow>
    );
  }
}

export default AbstractTable;



// WEBPACK FOOTER //
// ./src/components/common/AbstractTable.js